module.exports = __webpack_public_path__ + "img/SpectroPicPencil.aaeb5e12.png";